'use client';

import {useContext, useEffect, useState} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const DashboardPlatform = ({data}) => {
  const [marginTop, setMarginTop] = useState(0);
  const {theme} = useContext(ThemeContext);
  const {id, subtitle, color, title, list, image, imageLight} = data;
  const imgSrc = theme === 'dark' ? image : imageLight;
  const imgStyle = {backgroundImage: `url(${imgSrc})`};

  useEffect(() => {
    if (!window) return;
    function handleResize() {
      const origin = window.location.origin ? window.location.origin : '';
      if (origin.includes('localhost') && window.screen.width > 768) {
        setMarginTop(-2500);
      } else {
        setMarginTop(0);
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const listItems = list.map((item, index) => {
    const {listTitle, listText} = item;
    return (
      <li className='list-item' key={index}>
        <strong>{listTitle}</strong> {listText}
      </li>
    );
  });

  return (
    <section className={`dashboards ${id}`} id={id} style={{marginTop: `${marginTop}px`}}>
      <div className='container'>
        <div className='inner-container'>
          <h3 className={`subtitle ${color}`}>{subtitle}</h3>
          <h2 className='title'>{title}</h2>
          <ul className='list'>{listItems}</ul>
          <div className='img-container'>
            <div className='img' style={imgStyle} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DashboardPlatform;

